import React, { forwardRef } from 'react';

import { ReviewListItem, ReviewListItemProps } from './review-list-item';
import { useReviewsSelection } from '../context';

import { cn } from '@/lib/utils';

interface ReviewListProps {
  items: ReviewListItemProps[];
  className?: string;
}

export const ReviewList = forwardRef<HTMLUListElement, ReviewListProps>(({ items, className, ...props }, ref) => {
  const { selectedItem, setSelectedItem } = useReviewsSelection();

  return (
    <ul
      ref={ref}
      className={cn(
        'min-w-0 w-full overflow-hidden bg-muted border border-dark-300 rounded-lg p-2 space-y-2 list-none m-0',
        className,
      )}
      {...props}
    >
      {items.map((item) => (
        <li key={item.id}>
          <ReviewListItem {...item} isSelected={selectedItem?.id === item.id} onClick={() => setSelectedItem(item)} />
        </li>
      ))}
    </ul>
  );
});
ReviewList.displayName = 'ReviewList';
